angular.module('tf.services')

    .factory('ShareService', ['HttpService','FarmerService','$uibModal','$http','$q','$state','Session','UrlEncodingService','User',
        function (HttpService, FarmerService, $uibModal, $http, $q, $state, Session, UrlEncodingService, User) {
            var service = {};


            service.open = function(item){

                var modalInstance = $uibModal.open({
                    animation: true,
                    templateUrl: 'js/components/share/share.html',
                    controller: 'SharePopupController',
                    windowTopClass : 'share-modal',
                    keyboard : false,
                    //size: 500,
                    resolve: {
                        item : function(){return item;}
                    }
                });
            };

            service.share = function(item, emails, groups, privileges){
                if(!item.farm){item.farm = Session.farm._id;}
                var share = {
                    emails      : emails,
                    groups      : groups,
                    item        : item,
                    privileges  : privileges
                };
                var fid;
                try {
                    fid = item.fid || item.farmer.fid || FarmerService.current().fid;
                } catch(err) {
                    fid =  FarmerService.current().fid;
                }
                return HttpService.post("farmer/" + fid + "/share", share);
            };
            service.unshareFolder = function(folder){
                return HttpService.post("share/unshare-folder", {folder : folder});
            };
            service.unshareUser = function(user){
                return HttpService.post("share/unshare-user", {user : user});
            };

            service.unshare = function(user, asset){
                return HttpService.post("user/" + user.id + '/unshare', {asset : asset});
            };
            service.unshareGroup = function(group, asset){
                return HttpService.post("group/" + group.id + '/unshare', {asset : asset});
            };

            service.invite = function(emails){
                HttpService.post("invite",
                    {
                        emails : emails
                    })
                    .then(function (res) {
                        if(res.data.error){
                            //   alert(res.data.error);
                        } else {
                            //alert(res.data.share_url);
                        }
                    });
            };
            //
            //service.resolve = function(id){
            //    var defer = $q.defer();
            //    $http.get("/shares/" + id).then(function(res){
            //        if(res.data && res.data.shareEmail){
            //            Session.setEmail(res.data.shareEmail);
            //            if(res.data.isNew){
            //                $state.go('signup');
            //            } else {
            //                $state.go('login');
            //            }
            //        } else {
            //            $state.go('home');
            //        }
            //        defer.resolve();
            //    });
            //    return defer.promise;
            //};

            service.whoHasAccess = function(item){
                var defer = $q.defer();
                var fid;
                try {
                    fid = item.fid || item.farmer.fid || FarmerService.current().fid;
                } catch(err) {
                    fid =  FarmerService.current().fid;
                }
                HttpService.post("farmer/" + fid + "/permissions", {item:item}).then(function(res){
                    defer.resolve(res.data);
                });
                return defer.promise;
            };
            // service.getSharedUsers = function(folder){
            //     var defer = $q.defer();
            //     if(!folder) {
            //         HttpService.get("user/me/shared").then(function (res) {
            //             var users = [];
            //             for (var i = 0; i < res.data.length; i++) {
            //                 var user = res.data[i];
            //                 users.push(new User(user));
            //             }
            //             defer.resolve(users);
            //         });
            //     } else {
            //         HttpService.get("user/sharedto/" + folder ).then(function (res) {
            //             var users = [];
            //             for (var i = 0; i < res.data.length; i++) {
            //                 var user = res.data[i];
            //                 users.push(new User(user));
            //             }
            //             defer.resolve(users);
            //         });
            //     }
            //     return defer.promise;
            // };

            // service.getSharedFolders = function(userId){
            //     var defer = $q.defer();
            //     HttpService.get("user/" + userId + "/shared").then(function(res){
            //         defer.resolve(res.data);
            //     });
            //     return defer.promise;
            // };

            return service;
        }])
;
